import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const walletReducer = createReducer(initialState) ({
    [type.GET_WALLET]: (state, action) => ({
        ...state,
        get_wallet: action.payload,
    }),
});

export default walletReducer;